// @ts-nocheck

export const localeCodes =  [
  "de",
  "en",
  "fr",
  "it",
  "cs"
]
export const localeLoaders = {
  de: [
    {
      key: "locale_de_46json_165a3efe",
      load: () => import("#nuxt-i18n/165a3efe" /* webpackChunkName: "locale_de_46json_165a3efe" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_3676bfd9",
      load: () => import("#nuxt-i18n/3676bfd9" /* webpackChunkName: "locale_fr_46json_3676bfd9" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_2302d5d6",
      load: () => import("#nuxt-i18n/2302d5d6" /* webpackChunkName: "locale_it_46json_2302d5d6" */),
      cache: true
    }
  ],
  cs: [
    {
      key: "locale_cs_46json_ff50fd2c",
      load: () => import("#nuxt-i18n/ff50fd2c" /* webpackChunkName: "locale_cs_46json_ff50fd2c" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "de",
    name: "Deutsch",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "en",
    name: "English",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "fr",
    name: "Français",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "it",
    name: "Italiano",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "cs",
    name: "Čeština",
    language: undefined,
    domains: [],
    defaultForDomains: []
  }
]

